<template>
  <div class="page-wrapper">
    <LoadingSpinner v-if="isSubmitting" text="Procesando datos..." />

    <div class="container-fluid px-0 py-0">
      <div class="main-card shadow-sm">

        <div class="card-header-custom border-bottom">
          <div class="d-flex align-items-center">
            <button @click="goBack('AdministradorSubMenu', { subMenu: 'usuarios' })" class="btn-icon-back me-3"
              title="Volver">
              <i class="fas fa-arrow-left"></i>
            </button>
            <div>
              <h2 class="h4 mb-0 fw-bold text-dark">
                {{ isEditing ? "Editar Usuario" : "Nuevo Usuario" }}
              </h2>
              <p class="text-muted small mb-0 mt-1">
                {{ formSubtitleText }} </p>
            </div>
          </div>
        </div>

        <div class="card-body p-4">

          <section class="form-section mb-5">
            <h5 class="section-title mb-4"><i class="far fa-id-card me-2 text-primary"></i>Datos Personales</h5>

            <div class="row g-3 mb-3">
              <div class="col-md-4">
                <label class="form-label">Nombre <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0"><i class="fas fa-user text-muted"></i></span>
                  <input type="text" class="form-control border-start-0 ps-0" v-model="localFormData.name"
                    @input="clearError('name')" placeholder="Ej: Juan">
                </div>
                <span v-if="errors.name" class="text-danger small mt-1">{{ errors.name }}</span>
              </div>

              <div class="col-md-4">
                <label class="form-label">Apellido <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0"><i class="fas fa-user text-muted"></i></span>
                  <input type="text" class="form-control border-start-0 ps-0" v-model="localFormData.lastname"
                    @input="clearError('lastname')" placeholder="Ej: Pérez">
                </div>
                <span v-if="errors.lastname" class="text-danger small mt-1">{{ errors.lastname }}</span>
              </div>

              <div class="col-md-4">
                <label class="form-label">DNI <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0"><i
                      class="fas fa-address-card text-muted"></i></span>
                  <input type="number" class="form-control border-start-0 ps-0" v-model="localFormData.dni"
                    @input="clearError('dni')">
                </div>
                <span v-if="errors.dni" class="text-danger small mt-1">{{ errors.dni }}</span>
              </div>
            </div>

            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Email <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0"><i class="fas fa-envelope text-muted"></i></span>
                  <input type="email" class="form-control border-start-0 ps-0" v-model="localFormData.email"
                    @input="clearError('email')" placeholder="usuario@empresa.com">
                </div>
                <span v-if="errors.email" class="text-danger small mt-1">{{ errors.email }}</span>
              </div>
<div class="col-md-4">
                <label class="form-label">Celular <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0"><i
                      class="fas fa-mobile-alt text-muted"></i></span>
                  <input type="text" class="form-control border-start-0 ps-0" v-model="localFormData.personal_phone"
                    @input="clearError('personal_phone')">
                </div>
                <span v-if="errors.personal_phone" class="text-danger small mt-1">{{ errors.personal_phone }}</span>
              </div>
              <div class="col-md-4">
                <label class="form-label">Teléfono Fijo </label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0"><i class="fas fa-phone text-muted"></i></span>
                  <input type="text" class="form-control border-start-0 ps-0" v-model="localFormData.business_phone"
                    @input="clearError('business_phone')">
                </div>
                <span v-if="errors.business_phone" class="text-danger small mt-1">{{ errors.business_phone }}</span>
              </div>

              
            </div>
          </section>

          <UserAssignmentsList :assignments="localAssignments" :error-message="errors.assignments"
            @add="showModal = true" @edit="editAssignment" @remove="removeAssignment" @toggle-admin="toggleAdmin" />

          <section class="form-section">
            <h5 class="section-title mb-4"><i class="fas fa-user-shield me-2 text-primary"></i>Seguridad y Accesos</h5>

            <div class="row g-4 align-items-start">

              <div class="col-md-6">
                <div class="p-3 border rounded bg-white">

                   <div class="mb-3">
                    <label class="form-label">
                       {{ isEditing ? "Nueva Contraseña" : "Contraseña" }}
                       <small v-if="isEditing" class="text-muted fw-normal">(Opcional)</small>
                       <span v-else class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <span class="input-group-text bg-light border-end-0">
                        <i class="fas fa-lock text-muted"></i>
                      </span>

                      <input :type="showPassword ? 'text' : 'password'"
                        class="form-control border-start-0 border-end-0 ps-0" v-model="localFormData.password"
                        @input="clearError('password')" autocomplete="new-password"
                        :placeholder="isEditing ? 'Dejar vacío para mantener actual' : 'Ingrese contraseña'">

                      <span class="input-group-text bg-white border-start-0 cursor-pointer"
                        @click="showPassword = !showPassword">
                        <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" class="text-muted"></i>
                      </span>
                    </div>
                    <span v-if="errors.password" class="text-danger small mt-1">{{ errors.password }}</span>

                    
                  </div>

                  <transition name="slide-fade">
                    <div v-if="localFormData.password || !isEditing">
                      <label class="form-label">Confirmar Contraseña <span class="text-danger">*</span></label>
                      <div class="input-group">
                        <span class="input-group-text bg-light border-end-0">
                          <i class="fas fa-check-double text-muted"></i>
                        </span>

                        <input :type="showConfirmPassword ? 'text' : 'password'"
                          class="form-control border-start-0 border-end-0 ps-0" v-model="localFormData.confirm_password"
                          @input="clearError('confirm_password')" placeholder="Repita la contraseña">

                        <span class="input-group-text bg-white border-start-0 cursor-pointer"
                          @click="showConfirmPassword = !showConfirmPassword">
                          <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" class="text-muted"></i>
                        </span>
                      </div>
                      <span v-if="errors.confirm_password" class="text-danger small mt-1">
                        {{ errors.confirm_password }}
                      </span>

                      <!-- Strength Meter -->
                    <div class="strength-meter" v-if="localFormData.password">
                      <div class="strength-bar" :style="{ width: strengthInfo.width, backgroundColor: strengthInfo.color }"></div>
                    </div>

                    <!-- Requirements Checklist -->
                    <ul class="validation-list" v-if="localFormData.password || errors.password">
                      <li v-for="req in passwordRequirements" :key="req.id" 
                          class="validation-item" 
                          :class="{ 'valid': req.valid, 'invalid': !req.valid && (localFormData.password || req.id === 'match') }">
                        <i :class="req.valid ? 'fas fa-check-circle' : (localFormData.password || req.id === 'match' ? 'fas fa-times-circle' : 'fas fa-circle')"></i>
                        {{ req.label }}
                      </li>
                    </ul>
                    </div>
                  </transition>


                </div>
              </div>

              <div class="col-md-6">
                <div class="p-3 border rounded bg-light d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="form-check form-switch mb-0">
                      <input class="form-check-input" type="checkbox" role="switch" v-model="localFormData.joven"
                        style="width: 3em; height: 1.5em; cursor: pointer; margin-top: 0;">
                    </div>
                    <label class="form-check-label fw-bold ms-3 cursor-pointer user-select-none">
                      ¿ACARA Joven?
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>

        <div class="card-footer-custom p-4 bg-light border-top d-flex justify-content-end gap-2">
          <button class="btn btn-outline-secondary" @click="goBack('AdministradorSubMenu', { subMenu: 'usuarios' })">
            Cancelar
          </button>
          <button class="btn btn-primary px-4 shadow-sm" @click.prevent="submitForm" :disabled="isSubmitting">
            <i class="fas fa-save me-2"></i> {{ isEditing ? "Guardar Cambios" : "Crear Usuario" }}
          </button>
        </div>

      </div>
    </div>

    <ConcessionaireAssignmentModal :show="showModal" :assignment-to-edit="currentAssignmentToEdit"
      :existing-assignments="localAssignments" @close="closeModal"
      @add-assignment="handleAssignmentSave" />
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { createUser, updateUser, getUserById } from "@/services/api/concessionaire-user.js";
import useValidations from "@/composables/useValidations";
import { useGoBack } from "@/composables/concessionaire/useGoBack";
import Swal from "sweetalert2";

import ConcessionaireAssignmentModal from "./components/ConcessionaireAssignmentModal.vue";
import UserAssignmentsList from "./components/UserAssignmentsList.vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";

export default {
  props: { isEditing: Boolean },
  components: {
    ConcessionaireAssignmentModal,
    LoadingSpinner,
    UserAssignmentsList
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const { goBack } = useGoBack();

    const formSubtitleText = computed(() => {
      return props.isEditing
        ? 'Actualice la información del usuario'
        : 'Complete el formulario para dar de alta un nuevo usuario';
    });

    const isSubmitting = ref(false);
    const showModal = ref(false);
    const editingIndex = ref(-1);

    const showPassword = ref(false);
    const showConfirmPassword = ref(false);

    const { errors, validateFields, clearError } = useValidations();
    const userData = computed(() => store.state.userData || {});

    const localFormData = reactive({
      name: "", lastname: "", dni: "", email: "",
      personal_phone: "", business_phone: "",
      joven: false,
      password: "",
      confirm_password: ""
    });

    const passwordRequirements = computed(() => {
      const p = localFormData.password || "";
      const email = localFormData.email || "";
      const dni = localFormData.dni ? String(localFormData.dni) : "";
      
      return [
        { id: 'length', label: '+8 caracteres', valid: p.length >= 8 },
        { id: 'uppercase', label: 'Mayúscula', valid: /[A-Z]/.test(p) },
        { id: 'lowercase', label: 'Minúscula', valid: /[a-z]/.test(p) },
        { id: 'number', label: 'Número', valid: /[0-9]/.test(p) },
        { id: 'special', label: 'Especial', valid: /[!@#$%^&*(),.?":{}|<>]/.test(p) },
        { id: 'no-dni', label: 'No DNI', valid: dni ? !p.includes(dni) && p !== dni : true },
        { id: 'no-email', label: 'No Mail', valid: (p !== email && !!p) || !p },
        { id: 'match', label: 'Coinciden', valid: (p === localFormData.confirm_password && !!p) || (!p && !localFormData.confirm_password) }
      ];
    });

    const strengthInfo = computed(() => {
      const p = localFormData.password || "";
      let score = 0;
      if (p.length >= 8) score++;
      if (/[A-Z]/.test(p)) score++;
      if (/[0-9]/.test(p)) score++;
      if (/[!@#$%^&*(),.?":{}|<>]/.test(p)) score++;

      const colors = ['#dc3545', '#ffc107', '#28a745', '#1e7e34'];
      const widths = ['25%', '50%', '75%', '100%'];
      
      if (p.length === 0) return { width: '0', color: 'transparent' };
      const index = Math.min(score, 3);
      return { width: widths[index], color: colors[index] };
    });


    watch(() => localFormData.password, (newVal) => {
      if (!newVal) {
        localFormData.confirm_password = "";
        clearError('confirm_password');
      }
    });

    const localAssignments = ref([]);

    const currentAssignmentToEdit = computed(() => {
      return editingIndex.value >= 0 ? localAssignments.value[editingIndex.value] : null;
    });

    const editAssignment = (index) => {
      editingIndex.value = index;
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      editingIndex.value = -1;
    };

    const removeAssignment = (index) => {
      localAssignments.value.splice(index, 1);
    };

    const initializeFormData = (data = null) => {
      const u = data || userData.value;

      if (props.isEditing && u && (u.id || u.concessionaires)) {
        localFormData.name = u.name || "";
        localFormData.lastname = u.lastname || "";
        localFormData.dni = u.dni || "";
        localFormData.email = u.email || "";
        localFormData.personal_phone = u.personal_phone || "";
        localFormData.business_phone = u.business_phone || "";
        localFormData.joven = !!u.joven;

        localAssignments.value = [];

        if (u.concessionaires && u.concessionaires.length > 0) {
          const allPositions = u.positions || u.position || [];
          const userRoles = u.roles || [];

          u.concessionaires.forEach(conc => {
            const positionsForThis = allPositions.filter(p => {
              if (p.pivot && p.pivot.concessionaire_id == conc.id) return true;
              if (u.concessionaires.length === 1 && p.pivot && !p.pivot.concessionaire_id) return true;
              return false;
            });

            // Detectar si el usuario es admin en este concesionario específico.
            // Acepta también concessionaire_id == 0 o null para compatibilidad con
            // registros previos a la migración (si el usuario tiene solo un concesionario).
            const isSingleConc = u.concessionaires.length === 1;
            const isAdminForThis = userRoles.some(r => {
              if (r.name !== 'concessionaire-admin') return false;
              if (!r.pivot) return false;
              const pivotConcId = r.pivot.concessionaire_id;
              if (pivotConcId == conc.id) return true;
              if (isSingleConc && (pivotConcId === 0 || pivotConcId === null)) return true;
              return false;
            });

            localAssignments.value.push({
              concessionaire_id: conc.id,
              type: conc.type,
              business_name: conc.business_name,
              central_house: conc.central_house,
              cuit: conc.cuit,
              concessionaire_admin: isAdminForThis,
              positions: positionsForThis.map(p => ({
                id: p.id,
                name: p.name,
                area: p.area
              }))
            });
          });
        }
      }
    };

    const handleAssignmentSave = (assignment) => {
      if (editingIndex.value >= 0) {
        // Preservar el concessionaire_admin actual al editar
        const existing = localAssignments.value[editingIndex.value];
        localAssignments.value[editingIndex.value] = {
          ...assignment,
          concessionaire_admin: existing.concessionaire_admin ?? false,
          _isNew: true
        };
      } else {
        const index = localAssignments.value.findIndex(a => a.concessionaire_id === assignment.concessionaire_id);
        if (index !== -1) {
          localAssignments.value[index] = {
            ...assignment,
            concessionaire_admin: localAssignments.value[index].concessionaire_admin ?? false
          };
        } else {
          localAssignments.value.push({ ...assignment, concessionaire_admin: false, _isNew: true });
        }
      }
      clearError('assignments');
      closeModal();
    };

    const toggleAdmin = (index, value) => {
      if (localAssignments.value[index]) {
        localAssignments.value[index].concessionaire_admin = value;
      }
    };

    const submitForm = async () => {
      errors.assignments = null;

      const isPersonalDataValid = await validateFields(localFormData);

      let isPasswordValid = true;
      if (!props.isEditing && !localFormData.password) {
        errors.password = "La contraseña es obligatoria para nuevos usuarios.";
        isPasswordValid = false;
      }

      let isAssignmentsValid = true;
      if (localAssignments.value.length === 0) {
        errors.assignments = "Debe asignar al menos una concesionaria.";
        isAssignmentsValid = false;
      }

      if (!isPersonalDataValid || !isAssignmentsValid || !isPasswordValid) {
        return;
      }

      const incompleteAssignment = localAssignments.value.find(a => !a.positions || a.positions.length === 0);

      if (incompleteAssignment) {
        Swal.fire({
          icon: 'warning',
          title: 'Información Incompleta',
          html: `La concesionaria <b>${incompleteAssignment.business_name}</b> no tiene cargos asignados.<br><br>Por favor, edite la asignación y seleccione al menos un cargo.`,
          confirmButtonText: 'Entendido'
        });
        return;
      }

      isSubmitting.value = true;

      const payload = {
        ...localFormData,
        assignments: localAssignments.value.map(item => ({
          concessionaire_id: item.concessionaire_id,
          concessionaire_admin: item.concessionaire_admin ?? false,
          positions: item.positions.map(p => p.id)
        }))
      };

      try {
        if (props.isEditing) {
          await updateUser(userData.value.id, payload);
        } else {
          await createUser(payload);
        }
        Swal.fire("Éxito", `Usuario ${props.isEditing ? 'actualizado' : 'creado'} correctamente`, "success")
          .then(() => goBack('AdministradorSubMenu', { subMenu: 'usuarios' }, false));
      } catch (error) {
        console.error(error);
        const msg = error.response?.data?.message || "Error al procesar solicitud";
        Swal.fire("Error", msg, "error");
      } finally {
        isSubmitting.value = false;
      }
    };

    onMounted(async () => {
      if (props.isEditing && userData.value.id) {
        initializeFormData();
      } else if (props.isEditing && route.query.userId) {
        try {
          isSubmitting.value = true;
          const freshUser = await getUserById(route.query.userId);
          store.dispatch("updateUserData", freshUser);
          initializeFormData(freshUser);
        } catch (error) {
          console.error(error);
          Swal.fire("Error", "No se pudo recuperar la información.", "error")
            .then(() => goBack('AdministradorSubMenu', { subMenu: 'usuarios' }));
        } finally {
          isSubmitting.value = false;
        }
      }
    });

    return {
      localFormData, localAssignments, showModal, isSubmitting, errors,
      goBack, submitForm, removeAssignment, clearError,
      editAssignment, closeModal, handleAssignmentSave, currentAssignmentToEdit,
      toggleAdmin,
      showPassword,
      showConfirmPassword,
      formSubtitleText,
      passwordRequirements,
      strengthInfo
    };
  }
};
</script>

<style scoped>
.page-wrapper {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.main-card {
  background: white;
  border-radius: 0.75rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header-custom {
  padding: 1.5rem 2rem;
  background-color: white;
}

.card-footer-custom {
  background-color: #f8f9fa;
}

.btn-icon-back {
  background: transparent;
  border: 1px solid #e9ecef;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  transition: all 0.2s ease;
}

.btn-icon-back:hover {
  background-color: #e9ecef;
  color: #0d6efd;
}

.form-section {
  padding: 0 0.5rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #f1f3f5;
  padding-bottom: 0.75rem;
}

.cursor-pointer {
  cursor: pointer;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #343a40;
  margin-bottom: 0.4rem;
}

.input-group-text {
  background-color: #fff;
  border-color: #ced4da;
}

.form-control {
  border-color: #ced4da;
  padding: 0.6rem 0.75rem;
  font-size: 0.95rem;
}

.form-control:focus {
  box-shadow: none;
  border-color: #86b7fe;
  background-color: #fbfdff;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.gap-2 {
  gap: 0.5rem;
}

@media (max-width: 768px) {

  .card-header-custom,
  .card-body,
  .card-footer-custom {
    padding: 1rem;
  }
}

.validation-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
  padding-left: 0;
  list-style: none;
  justify-content: flex-start;
}

.validation-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  background-color: #f1f3f5;
  color: #495057;
  border: 1px solid #dee2e6;
  transition: all 0.3s ease;
}

.validation-item.valid {
  background-color: #e6ffed;
  color: #28a745;
  border-color: #28a745;
}

.validation-item.invalid {
  background-color: #fff5f5;
  color: #dc3545;
  border-color: #dc3545;
}

.validation-item i {
  font-size: 10px;
}

.strength-meter {
  height: 4px;
  width: 100%;
  background-color: #eee;
  border-radius: 2px;
  margin-top: 8px;
  overflow: hidden;
}

.strength-bar {
  height: 100%;
  width: 0;
  transition: width 0.3s ease, background-color 0.3s ease;
}
</style>